import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import React, { useEffect, useState} from "react";
import { sbaAxios } from "../../utils/sbaAxios";
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { getExceptionEntTolerances, getExceptionValueTypes, insertOrUpdateTolerance, getMarketDataIndices, deleteTolerance, getExceptionAssets, getexceptionTypes, getExceptionTypeDetails } from "../../../config/apiConfig";
import { useNavigate, useParams } from "react-router-dom";
import {  SBAComboBox } from "../../UiComponents/SBADropDown";
import { ToastContainer, toast } from 'react-toastify';
import { SBNotify } from "../../utils/sbNotify";
import { useRef } from "react";
export const Tolerance = () => {
    
    const [gridata, setGriddata] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedName, setselectedName] = useState([]);
    const [Valuetypes, setValuetypes] = useState([]);
    const [selectedvaluetype, setselectedvaluetype] = useState([]);
    const [Minvalue, setMinvalue] = useState([]);
    const [Maxvalue, setMaxvalue] = useState([]);
    const [selectedAsset, setselectedAsset] = useState([]);
    const [Assets, setAssets] = useState([]);
    const [Exceptions, setExceptions] = useState([]);
    const [selectedException, setselectedException] = useState([]);
    const [selectedEditAsset, setselectedEditAsset] = useState([]);
    const [Tolid, setTolid] = useState([]);
    const [isActive, setisActive] = useState([]);
    const [marketindex, setmarketindex] = useState([]);
    const [selectedMarketIndex, setselectedMarketIndex] = useState([]);
    const param=useParams();
    const history = useNavigate();
    const ref=useRef();

    useEffect(() => {
       
        GetExceptionValueTypes();
        GetExceptionAssets();
        GetExceptionTypes();
        getMarketIndexData();
    }, [])


    useEffect(() => {
        if (selectedAsset)
         GetExceptionEntTolerance();
    }, [selectedAsset])

    const assetchange = (e) => {
        setselectedAsset(e.value)
        setselectedEditAsset(e.value)
    }
    const Asseteditchange = (e) => {
       
        setselectedEditAsset(e.value)
    }


    const getMarketIndexData = async () => {
        try {
            const resposne = await sbaAxios({ url: getMarketDataIndices })
            setmarketindex(resposne);
        } catch (error) {
            console.log("Error Fetching Data For Market Index");
           
        }
    };

    const GetExceptionTypes = async () => {
        try {
            const response = await sbaAxios({

                url: `${getexceptionTypes}?exceptionTypeId=${null}`,
                method: 'get',
            })
            if (response) {
                setExceptions(val=>response.filter(item=>item.IsActive))
            }
        }
        catch (error) {

        }

    }
    const GetExceptionAssets = async () => {

        try {
            const response = await sbaAxios({

                url: `${getExceptionAssets}`,
                method: 'get',
            })
            if (response) {
                const value = [
                    { AssetName: "--- Please Select ---", AssetId: null },
                    ...response
                ];

                setAssets(value);
                setselectedAsset(value[0]);
                setselectedEditAsset(value[0]);      
            
            }
        }
        catch (error) {

        }
    }
    const GetExceptionValueTypes = async () => {
        try {
            const response = await sbaAxios({

                url: `${getExceptionValueTypes}`,
                method: 'get',
            })
            if (response) {
                setValuetypes(response);
            }
        }
        catch (error) {

        }
    }
    const GetExceptionEntTolerance = async (res) => {
        try {
            const response = await sbaAxios({

                url: `${getExceptionEntTolerances}?entityId=${selectedAsset?.AssetId||null}`,
                method: 'get',
            })
            if (response) {
                setGriddata(response);
                setTimeout(() => {
                    if(res)
                    selectRowById(res)
                }, 100); 
            }
        }
        catch (error) {

        }
    }
    const selectRowById = (idToSelect) => {
        const api = ref?.current?.api;
        api?.forEachNode((node) => {
          if (node.data.ExceptionEntTolId === idToSelect) {
            node.setSelected(true);
          }
        });
      };
    const Addclk = () => {
        setShow(true);
        setMinvalue("");
        setMaxvalue("");
        setselectedvaluetype("");
        setselectedException("");
        setselectedName("");
        setselectedEditAsset(selectedAsset || Assets[0]);
        setTolid(0);
        setselectedMarketIndex("");
        setisActive(true);
    }

    const defaultColDef = {
        sortable: false,
        Filter: true,
        floatingFilter: true,
        suppressMovable: true,
        flex: 1,
        resizable: true,
        autoHeaderHeight: true,
    };

    // GetException Type Details

    const GetExceptionTypeDetails = async (exceptionTypeId) => {
        try {
            const response = await sbaAxios({

                url: `${getExceptionTypeDetails}/${exceptionTypeId}`,
                method: 'get',
            })
            if (response) {
                setselectedvaluetype({
                    ExceptionValueTypeId: response.ExceptionValueTypeId,
                    ExceptionValueTypeName:response.ExceptionValueTypeName
                });
            }
        }
        catch (error) {

        }

    }
    const ExceptionToleranceSave = () => {
        let issave = true;
        const savedata =
        {
            "exceptionEntTolId": Tolid,
            "exceptionTypeId": selectedException.ExceptionTypeId,
            "entityId": selectedEditAsset.AssetId,
            "entityTypeId": 1,
            "marketIndexId": selectedMarketIndex?.MarketIndexId || 0,
            "minValue": Minvalue || 0,
            "maxValue": Maxvalue || 0,
            "isActive": isActive
        }
        if (selectedvaluetype.length !== 0) {
            const min = Number(Minvalue);
            const max = Number(Maxvalue);

            if (selectedvaluetype.ExceptionValueTypeId === 1 || selectedvaluetype.ExceptionValueTypeId === 5) {
                if (max > 9999 || min < -9999) {
                    issave = false;
                    SBNotify({ Msg: "Min and Max value should be in the range of -9999 to 9999", type: "error" });
                }
            }
            else if (selectedvaluetype.ExceptionValueTypeId === 2) {
                if (max > 100 || min < -100) {
                    issave = false;
                    SBNotify({ Msg: "Min and Max value should be in the range of -100 to 100", type: "error" });
                }
            } else if (selectedvaluetype.ExceptionValueTypeId === 3 || selectedvaluetype.ExceptionValueTypeId === 4) {
                if (max > 999 || min < 0) {
                    issave = false;
                    SBNotify({ Msg: "Min and Max value should be in the range of 0 to 999", type: "error" });
                }
            }
        }

        if (!selectedEditAsset.AssetId) {
            issave = false
            SBNotify({ Msg: "Please select the Asset", type: "error" });
        }

        // if (!selectedMarketIndex.MarketIndexId) {
        //     issave = false
        //     SBNotify({ Msg: "Please select the Market Index", type: "error" });
        // }

        if (!selectedException.ExceptionTypeId) {
            issave = false
            SBNotify({ Msg: "Please select the Exception Type", type: "error" });
        }

        if (issave)
        try {
            sbaAxios({
                url: `${insertOrUpdateTolerance}`,
                method: "post",
                data: savedata
            }).then((res) => {
                SBNotify({
                    Msg: " Exception Tolerance Save Successfully",
                    type: "success",
                });
                setShow(false);
                GetExceptionEntTolerance(res);

            })

        }
        catch (error) {
            SBNotify({ Msg: error, type: "error" });
        }

    }
    //  DeleteExceptionTypeDetails
    const DeleteExceptiontolid = async (Toleranceid) => {
        try {
            const response = await sbaAxios({

                url: `${deleteTolerance}/${Toleranceid}`,
                method: 'get',
            })
            if (response) {
                SBNotify({
                    Msg: " Exception Tolerance delete Successfully",
                    type: "success",
                });
                GetExceptionEntTolerance();
            }
            else {
                SBNotify({
                    Msg: "Some Error Occure while delete Tolerance",
                    type: "error",
                });
            }
        }
        catch (error) {
            SBNotify({ Msg: error, type: "error" });
        }

    }

    const ActionRenderer = (props) => {
        const Editdatas = props.data;

        const handleDeleteClick = () => {
            DeleteExceptiontolid(Editdatas.ExceptionEntTolId);
        };
        const handleEditClick = () => {

            setShow(true);
            setMinvalue(Editdatas.MinValue)
            setMaxvalue(Editdatas.MaxValue)
            setselectedvaluetype({
                ExceptionValueTypeId: Editdatas.ExceptionValueTypeId,
                ExceptionValueTypeName: Editdatas.ExceptionValueTypeName
            });
            setselectedException({ExceptionTypeId: Editdatas.ExceptionTypeId, ExceptionTypeName: Editdatas.ExceptionTypeName})
            setselectedName(Editdatas.EntityName)
            setselectedEditAsset({
                AssetId: Editdatas.EntityId,
               AssetName: Editdatas.EntityName
            });
            setselectedMarketIndex({
                MarketIndexId: Editdatas.MarketIndexId,
                MarketIndexName: Editdatas.MarketIndexName,});
            setisActive(Editdatas.IsActive);
            setTolid(Editdatas.ExceptionEntTolId);

        };
        return (
            <div className="actions-cell">
                <i className="fas fa-trash" style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
                <i
                    className="fas fa-edit"
                    style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i>
            </div>
        );
    };

    const ColumnDefs = [
        { headerName: 'Entity Name', field: 'EntityName', filter: "agTextColumnFilter" },
       
        {
            headerName: 'Exception Type Name',
            field: 'ExceptionTypeName',
            filter: "agTextColumnFilter"
          
        },
        {
            headerName: 'Exception Value TypeName',
            field: 'ExceptionValueTypeName',
            filter: "agTextColumnFilter"


        },
        {
            headerName: 'Market Index Name',
            field: 'MarketIndexName',
            filter: "agTextColumnFilter"

        },
        {
            headerName: ' IsActive',
            field: 'IsActive',
            filter: "agTextColumnFilter",

            cellRenderer: params => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <input type="checkbox" checked={params.value}  />
                </div>
            ),
            

        },
        {
            headerName: 'Min Value',
            field: 'MinValue',
            filter: "agTextColumnFilter"

        },

        {
            headerName: 'Max Value',
            field: 'MaxValue',
            filter: "agTextColumnFilter"

        },

        {

            headerName: 'Action',
            field: 'Action',
            cellRenderer: ActionRenderer,
            filter: "agTextColumnFilter"


        }
    ];
    
    return <>

        <div className="row">
            <div class="col-lg-12 col-md-12 bg-white  rounded">
                <div className="col-md-3">
                    <label
                        for="select fund"
                        className="mb-1 ms-2 fw-semibold  fs-12 d-block"
                    >
                        Asset
                            </label>
                    <SBAComboBox
                        onChange={assetchange}
                        value={selectedAsset}
                        className="AssetDropDown input-default"
                        textField={"AssetName"}
                        valueField={"AssetId"}
                        placeholder="---Please Select---"
                        data={Assets}
                    />
                </div>

            <div className="d-flex justify-content-end gap-2">
                    <button className="p-sm-btn mx-1" onClick={Addclk}>
                    <i className="fa-solid fa-plus" /> Add
                      </button>
                    
                </div>
                            <div className="ag-theme-alpine mt-3" style={{ height: "90vh", width: "100%" }}>
                                <AgGridReact ref={ref} rowSelection="single" rowData={gridata} columnDefs={ColumnDefs} defaultColDef={defaultColDef}/>
                            </div>
                       
                <SBADrawer
                    open={show}
                    setOpen={setShow}
                    close={false}
                    title={"Add /Edit Tolerance"}
                >
                    <div className="drawer">
                        <div>
                            <div className="col-lg-12 px-0">
                                <div className="row m-2">
                                 <div className="row mb-4">
                                     <div className="col-auto ">
                                        <input
                                            type="checkbox"
                                            checked={isActive}
                                            onChange={() => {
                                                setisActive(!isActive);
                                                
                                            }}

                                        />

                                            <span className="fw-medium ps-4 me-2" >Is Active</span>

                                        </div>
                                    </div>
                                    <div className="row mb-4">                                       
                                            <label
                                                for="select fund"
                                                className="mb-1 ms-2 fw-semibold  fs-12 d-block"
                                            >
                                            Asset
                                            </label>
                                        <div>
                                            <SBAComboBox
                                                onChange={Asseteditchange}
                                                value={selectedEditAsset}
                                                className="w-50"
                                                textField={"AssetName"}
                                                valueField={"AssetId"}
                                                popupSettings={{ className: "modalDD" }}
                                                data={Assets}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-4">

                                        <label className="mb-1 label">Exception Type</label>
                                        <div>
                                            <SBAComboBox
                                                className="w-50"
                                                popupSettings={{ className: "modalDD" }}
                                                data={Exceptions}
                                                textField={"ExceptionTypeName"}
                                                valueField={"ExceptionTypeId"}
                                                value={selectedException}
                                                placeholder="---Please Select---"
                                                onChange={(e) => {
                                                    setselectedException(e.value);
                                                    GetExceptionTypeDetails(e.value.ExceptionTypeId);
                                                }}


                                            />
                                        </div>

                                    </div>

                                    <div className="row mb-4">
                                        
                                        <label className="mb-1 label">Value Type</label>

                                        <div>
                                            <input
                                                className="form-control w-50"
                                                type="text"
                                                value={selectedvaluetype?.ExceptionValueTypeName}
                                                disabled

                                            />
                                        </div>

                                           
                                        
                                    </div>
                                    <div className="row mb-4">
                                       
                                            <label className="header-container m-1">
                                                Min Value
                                          </label>
                                            <div>
                                                <input
                                                    className="form-control w-50"
                                                    type="text"
                                                    value={Minvalue}
                                                onChange={(e) => setMinvalue(e.target.value)}

                                                />
                                            </div>
                                        
                                    </div>
                                    <div className="row mb-4">

                                        
                                            <label className="header-container m-1">
                                                Max Value
                                          </label>
                                        <div>
                                            <input
                                                className="form-control w-50"
                                                type="text"
                                                    onChange={(e) => setMaxvalue(e.target.value)}
                                                    value={Maxvalue}
                                                
                                                />
                                            </div>
                                       
                                    </div>


                                    <div className="row mb-4">

                                        <label className="mb-1 label">Market Index</label>
                                        <div>
                                            <SBAComboBox
                                                className="w-50"
                                                popupSettings={{ className: "modalDD" }}
                                                data={marketindex}
                                                textField={"MarketIndexName"}
                                                valueField={"MarketIndexId"}
                                                value={selectedMarketIndex}
                                                placeholder="---Please Select---"
                                                onChange={(e) => {
                                                    setselectedMarketIndex(e.value);
                                                   
                                                }}


                                            />
                                        </div>

                                    </div>

                                   

                                </div>
                            </div>
                            <div className="mt-5">
                                <button className="s-sm-btn mx-1" onClick={() => {
                                    setShow(false);
                                }}>
                                    Cancel
                            </button>
                                <button className="p-sm-btn mx-1" onClick={ExceptionToleranceSave}>
                                    Save
                           </button>
                            </div>
                        </div>
                    </div>
                </SBADrawer>
                
            </div>
            {/*<ToastContainer></ToastContainer>*/}
        </div>

        
    </>

}

export const getCurrencyFormat = (number, decimalnumber = 2, currencyCode = 'USD', locale = 'en-US') => {
    try {
      if (number == null || Number(number) === 0 || isNaN(Number(number))) {
        return '';
      }
      const decimalPlaces = Math.max(0, parseInt(decimalnumber, 10) || 0);
  
      const formattedCurrency = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(Number(number));
  
      return formattedCurrency;
    } catch (error) {
      console.error('Error formatting currency:', error);
      return '';
    }
  };
  